// @Vendors
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const moment = require('moment');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @Actions
const actionTypes = require('constants/actionTypes');
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern');

// @Utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @Constants
const {
    BROKER_RIGHTS_CASH_EXCHANGE_ERROR_RIGHTS_INPUT,
    BROKER_RIGHTS_CASH_EXCHANGE_OPERATION_TYPE,
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    BROKER_ORDER_TYPE_CASH_EXCHANGE,
    BROKER_CORPORATE_OPERATIONS_CASH_EXCHANGE_PRODUCT_TYPE,
    CONNECTION_CHANNEL_INTERNET,
    CHARGE_ACCOUNT_PREFIX,
    DATE_FORMAT_API
} = require('constants/index');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');

const validateSuccess = () => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_VALIDATE_STEP_SUCCESS
});

const validateCCSuccess = () => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_VALIDATE_CC_SUCCESS
});

const validateFaiure = errorSource => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_VALIDATE_STEP_FAILURE,
    payload: {
        errorSource
    }
});

const setRightsQuantity = rightsQuantity => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_CHANGE_QUANTITY_INPUT,
    payload: {
        rightsQuantity
    }
});

const setOperationFailure = error => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_SET_FAILURE,
    payload: {
        error
    }
});

const setOperationData = (selectedContract, selectedOperation) => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_SET_OPERATION_DATA,
    payload: {
        selectedContract,
        selectedOperation
    }
});

const validateWithAPIRequested = () => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_VALIDATION_REQUESTED
});

const changeRightsQuantity = rightsQuantity => (dispatch) => {
    const parsedRightsQuantity = Number(rightsQuantity) || 0;
    dispatch((setRightsQuantity(parsedRightsQuantity)));
}

const setVisibleStep = step => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
}

const setWillCancel = willCancel => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_SET_WILL_CANCEL,
        payload: {
            willCancel
        }
    });
}

const setSelectedOperation = selectedIndex => (dispatch, getState) => {
    const immCorporateOperations = getState().brokerCorporatesOperations;
    const immSelectedContract = immCorporateOperations.get('selectedContract');
    const immSelectedOperation = immSelectedContract ? immSelectedContract.getIn(['operations', selectedIndex]) : undefined;
    if(!immSelectedContract || !immSelectedOperation) {
        dispatch(setOperationFailure());
    } else {
        dispatch(setOperationData(immSelectedContract, immSelectedOperation));
    }
}

const setConfirmOrderSuccess = (confirmationResponse) => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_SET_CONFIRM_SUCCESS,
    payload: {
        confirmationResponse
    }
});

const changeManifest = () => dispatch => {
    dispatch({
        type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_CHANGE_MANIFEST,
        payload: {}
    });
};

const setLegalOptionChange = (value) => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_CHANGE_LEGAL_OPTION,
    payload: {
        value
    }
})

const getConfirmationRequestObject = (immBrokerRightsCashExchange, dataToken, getState) => {
    const immSelectedOperation = immBrokerRightsCashExchange.get('selectedOperation');
    const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
    const rightsQuantity = immBrokerRightsCashExchange.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
    const codemisioncc = immSelectedOperation.get('codigoEmision');
    const codvalorinternocc = immSelectedOperation.get('codigoValorInterno');
    const numerodecontrato = immSelectedContract.getIn(['contract', 'number']);
    const producto = immSelectedContract.getIn(['contract', 'product']);
    const immBrokerProductFile = getState().brokerProductFile;
    const productManager = immBrokerProductFile.get('companyName', '');
    const productIsin = trim(immSelectedOperation.get('isin'));
    const micCode = trim(immSelectedOperation.get('iso'));
    const agentId = 'WEB'; //hard coded
    const currency = immBrokerProductFile.getIn(['productValue', 'currency'], '');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const requestObject = {
        header: {
            version: 2
        },
        query: {
            codEmisionInterno: {
                codemisioncc,
                codvalorinternocc
            },
            contratoValores: {
                numerodecontrato,
                producto
            },
            //indicadorPorcentaje: BROKER_RIGHTS_CASH_EXCHANGE_PERCENTAGE_INDICATOR, // OPCIONAL
            //porcentajeEfectivo: BROKER_RIGHTS_CASH_EXCHANGE_EFECTIVE_PERCENTAGE, // OPCIONAL
            tipoOperacion: BROKER_RIGHTS_CASH_EXCHANGE_OPERATION_TYPE,
            numTitulos: rightsQuantity,
            initQuantity: rightsQuantity,
            productIsin,
            productManager,
            micCode,
            agentId,
            dataToken,
            currency,
            documentationId: uuid
        }
    }
    return requestObject;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const storeDocument = (cashExchangeResponse, history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immBrokerRightsCashExchange = getState().brokerRightsCashExchange;
    const immBrokerProductFile = getState().brokerProductFile;

    const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
    const immSelectedOperation = immBrokerRightsCashExchange.get('selectedOperation');

    const idOrder = trim(get(cashExchangeResponse, 'numeroOrden'));
    const orderTimestamp =
        get(cashExchangeResponse, 'timestamp') ||
        get(cashExchangeResponse, 'timeResponse.timestamp');
    const momentEmittedDateTime = isNaN(orderTimestamp)? momentTz().tz("Europe/Madrid") : momentTz(Number(orderTimestamp)).tz("Europe/Madrid");

    const controlDigit = trim(immSelectedContract.getIn(['cuenta', 'digitodecontrol']));
    const productNumber = trim(immSelectedContract.getIn(['contract', 'product']));
    const contractNumber = trim(immSelectedContract.getIn(['contract', 'number']));
    const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const ccc = !__CONTACT_CENTER__ ?
        immSelectedContract.getIn(['associatedAccount', 'number'], '') :
        trim(get(cashExchangeResponse, 'cuentaAsociada.codbban'));

    const owner = trim(immSelectedContract.get('owner'));
    const momentEndDate = moment(immSelectedOperation.get('endDate', ''));

    const titlesAmount = immBrokerRightsCashExchange.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
    const sharesNumber = Number(titlesAmount) || 0;

    const marketName = trim(immBrokerProductFile.get('marketName')) || '';
    const productValue = Number(immBrokerProductFile.getIn(['productValue','amount'])) || 0;
    const currency = trim(immBrokerProductFile.get('currency')) || '';
    const sharesAmount = productValue * sharesNumber;

    const query = {
        productKID: '',
        contract: '',
        marketingReport: '',
        infoCcv: '',
        sendOrder: 'No',
        idOrder,
        market: marketName,
        termValidity: momentEndDate.format(DATE_FORMAT_API),
        holders: owner,
        leafletSusbcription: trim(immBrokerRightsCashExchange.getIn(['selectedOperation', 'linkTriptico'])),
        cnmvDocumentation: trim(immBrokerRightsCashExchange.getIn(['selectedOperation', 'linkCNMV'])),
        ccv: idContract,
        ccc,
        idContract: idContract,
        email: trim(PersonalDataHelper.getEmail(immProfile)),
        clientAlias: trim(immProfile.get('nombreCliente')),
        isin: trim(immSelectedOperation.get('isin')),
        isinDescribe: trim(immSelectedOperation.get('descriptionValue')),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_CASH_EXCHANGE,
        productType: BROKER_CORPORATE_OPERATIONS_CASH_EXCHANGE_PRODUCT_TYPE,
        sharesNumber,
        sharesAmount,
        orderCondition: '',
        conditionPrize : '',
        currency: currency,
        mifidWarningText: generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        dateTime: momentEmittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    const url = apiURLBuilder.getURL('communication');

    APIPost(dispatch, url, { query }).catch(() => dispatch(errorActions.show('', true, history)));
}

function confirmOrderRequest() {
    return {
        type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_CONFIRM_REQUEST
    };
}

const confirmOrder = (dispatch, getState, dataToken, history) => {
    const url = apiURLBuilder.getURL('brokerDividendosEleccion');
    const immBrokerRightsCashExchange = getState().brokerRightsCashExchange;
    const queryObject = getConfirmationRequestObject(immBrokerRightsCashExchange, dataToken, getState);
    dispatch(confirmOrderRequest());
    APIPost(dispatch, url, queryObject)
        .then(response => {
            dispatch(setConfirmOrderSuccess(response));
            dispatch(storeDocument(response, history));
        })
        .catch(response => {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
}



const getValidationRequestObject = (immBrokerRightsCashExchange) => {
    const immSelectedOperation = immBrokerRightsCashExchange.get('selectedOperation');
    const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
    const rightsQuantity = immBrokerRightsCashExchange.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
    const codemisioncc = immSelectedOperation.get('codigoEmision');
    const codvalorinternocc = immSelectedOperation.get('codigoValorInterno');
    const numerodecontrato = immSelectedContract.getIn(['contract', 'number']);
    const producto = immSelectedContract.getIn(['contract', 'product']);

    const requestObject = {
        query: {
            codEmisionInterno: {
                codemisioncc,
                codvalorinternocc
            },
            contratoValores: {
                numerodecontrato,
                producto
            },
            tipoOperacion: BROKER_RIGHTS_CASH_EXCHANGE_OPERATION_TYPE,
            titulos: rightsQuantity
        }
    }
    return requestObject;
}

const validateWithAPI = (dispatch, getState, history) => {
    const url = apiURLBuilder.getURL('brokerDividendosEleccionValidacion');
    const immBrokerRightsCashExchange = getState().brokerRightsCashExchange;
    const queryObject = getValidationRequestObject(immBrokerRightsCashExchange);
    dispatch(validateWithAPIRequested());
    APIPost(dispatch, url, queryObject)
        .then(() => {
            dispatch(validateSuccess());
        })
        .catch(response => {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
}

const validateStep1 = (dispatch, getState, history) => {
    const immStep1 = getState().brokerRightsCashExchange.getIn(['steps', FIRST_STEP]);
    const validRightsQuantity = immStep1.get('rightsQuantity') > 0;
    if(validRightsQuantity) {
        validateWithAPI(dispatch, getState, history);
    } else {
        dispatch(validateFaiure(BROKER_RIGHTS_CASH_EXCHANGE_ERROR_RIGHTS_INPUT));
    }
}

const validateStep2 = (dispatch, getState) => {
    const immStep2 = getState().brokerRightsCashExchange.getIn(['steps', SECOND_STEP]);
    const valid = immStep2.get('valid');

    if (valid) {
        dispatch(validateSuccess());
    } else {
        dispatch(validateFaiure());
    }
}

const validateLegalConfirmation = (selectedOperation, selectedContract) => ({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_VALID_LEGAL_CONFIRMATION,
    payload: {
        selectedOperation,
        selectedContract
    }
});

const finishOperation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(confirmOrder(dispatch, getState, dataToken, history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const validateSignaturePattern = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        confirmOrder(dispatch, getState, dataToken);
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const validateStep = (step, history) => (dispatch, getState) => {
    const selectedOperation = getState().brokerRightsCashExchange.get('selectedOperation');
    const selectedContract = getState().brokerRightsCashExchange.get('selectedContract');
    const validLegalConfirmation = getState().brokerRightsCashExchange.get('validLegalConfirmation');
    if (__CONTACT_CENTER__){
        if (!validLegalConfirmation) {
            const valid = getState().brokerRightsCashExchange.get('selectedLegalConfirmation') === SELECTED_VALUES.YES;
            if (valid) {
                dispatch(validateCCSuccess());
                dispatch(validateLegalConfirmation(selectedOperation,selectedContract));
            } else {
                dispatch(validateFaiure());
            }
        }
        if (step === WIZARD_SECOND_STEP) {
            validateStep1(dispatch, getState, history);
        }
        else {
            validateStep2(dispatch, getState);
            const valid = getState().brokerRightsCashExchange.getIn(['steps', SECOND_STEP,'valid'])
            if (valid) {
                dispatch(validateSignaturePattern());
            }
        }
    } else {
        if(step === WIZARD_FIRST_STEP) {
            validateStep1(dispatch, getState, history);
        } else {
            validateStep2(dispatch, getState);
        }
    }
}

const reset = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_RESET
    });
}

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_RIGHTS_CASH_EXCHANGE_DOCUMENTS_READ
});

module.exports = {
    changeRightsQuantity,
    finishOperation,
    reset,
    setSelectedOperation,
    setLegalOptionChange,
    setVisibleStep,
    setWillCancel,
    validateStep,
    changeManifest,
    setDocumentsRead
}
